module.exports = __webpack_public_path__ + "static/Additional-Guidance-for-Our-Insureds.v2-32425b3081633e3540c8bf1aeb9bab2f.pdf";